import numeral from 'numeral'

const formatNumberCurrencyPlugin2 = {
  install (Vue) {
    Vue.prototype.$formatNumberCurrency2 = (value) => {
      // Manejar valores nulos, indefinidos o strings vacíos
      if (value === null || value === undefined || value === '') {
        return '$0.00'
      }
      console.log('VALOR DE VALUE', value)
      const number = Number(value)

      // Validar si es un número válido antes de pasarlo a numeral
      if (isNaN(number)) {
        return value
      }

      const formatted = numeral(number).format('0,0.00')
      return formatted === 'NaN' ? value : `$${formatted}`
    }
  }
}

export default formatNumberCurrencyPlugin2
